import { InjectionToken } from '@angular/core';
import { SdModalOptionsWithBreakpoints } from '@shared/v2/models';

export const SD_MODAL_OPTIONS_TOKEN = new InjectionToken<SdModalOptionsWithBreakpoints>('SD_MODAL_OPTIONS');
